import React, { Component } from 'react';
import fetch from 'cross-fetch';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import TextField from '../bits/TextField.jsx';
import NavBar from './NavBar.jsx';

class AuthForm extends Component {
  state = {
    isLoading: false,
    errorCode: null,
    otp: '',
  }

  nextDisabled = () => (this.state.otp.length === 0);

  onSubmit = () => {
    this.setState({
      isLoading: true,
    });

    fetch('/users/auth', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        email: this.props.values.email,
        method: 'otp',
        value: this.state.otp,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('auth_form.error_generic');
        }

        return response.json();
      })
      .then((json) => {
        if (!json.result) {
          this.setState({
            errorCode: 'auth_form.error_invalid_code',
            isLoading: false,
          });
          return;
        }

        this.props.onNext();
      })
      .catch((e) => {
        this.setState({
          errorCode: 'auth_form.error_generic',
          isLoading: false,
        });

        // Unexpected errors, so re throw
        throw e;
      });
  };

  handleChange = input => (e) => {
    this.setState({ [input]: e.target.value });
  }

  render() {
    const { onBack, t } = this.props;

    return (
      <div>
        <h2>{t('auth_form.title')}</h2>
        <p>{t('auth_form.instruction')}</p>
        <div className="form-group">
          <TextField
            id="inputAuth"
            inputProps={{
              type: 'text',
              pattern: '\\d*',
            }}
            label={t('auth_form.input_label')}
            value={this.state.otp}
            onChange={this.handleChange('otp')}
            fullWidth
            margin="normal"
            error={Boolean(this.state.errorCode)}
            helperText={t(this.state.errorCode)}
          />
        </div>
        <NavBar
          isLoading={this.state.isLoading}
          onNext={this.onSubmit}
          nextDisabled={this.nextDisabled()}
          onBack={onBack} />
      </div>
    );
  }
}

AuthForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default withTranslation('activation_wizard')(AuthForm);
